export class ListOptions {
  allowAdding: boolean;
  allowDeleting: boolean;
  allowEditing: boolean;
  allowReset: boolean;

  showOptions: boolean;

  constructor(options: {
    allowAdding?: boolean;
    allowDeleting?: boolean;
    allowEditing?: boolean;
    allowReset?: boolean;
    showOptions?: boolean;
  }) {
    this.allowAdding = options.allowAdding == true;
    this.allowDeleting = options.allowDeleting == true;
    this.showOptions = options.showOptions == true;
    this.allowEditing = options.allowEditing == true;
    this.allowReset = options.allowReset == true;
  }
}
